import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label } from '@fluentui/react';
export const styles_red = {
    // TODO: get this color from theme.
    color: 'rgb(164, 38, 44)',
    fontSize: 12,
    fontWeight: 'normal',
    fontFamily: `"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif`,
};
export default function FluentLabel({ label, required, id }) {
    return (_jsxs(Label, { htmlFor: id, children: [label, required && _jsx("span", { style: styles_red, children: "\u00A0*" })] }));
}
//# sourceMappingURL=FluentLabel.js.map